// @flow
import * as React from "react";
import styles from "./ButtonsGroup.scss";

type ButtonsGroupProps = {
  children: React.Node
};

const ButtonsGroup = ({ children }: ButtonsGroupProps) => (
  <div className={styles.container}>{children}</div>
);

export default ButtonsGroup;
